import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { NavDropdown } from 'react-bootstrap';
import { FaUser, FaUserTie, FaUserCheck } from 'react-icons/fa';
import './UploadAvatar.css'; // Your custom styles
import logoImage from './NRDRUHSLogo.png'; // Import the logo image
import NRDRUHSHeader from './NRDRUHSHeader'
import NRDRUHSFooter from './NRDRUHSFooter';
import { Helmet } from 'react-helmet';


function Publications() {
    const [showMenu, setShowMenu] = useState(false);
    const [scrolling, setScrolling] = useState(false);

    const toggleMenu = () => {
        setShowMenu(prev => !prev);
    };

    useEffect(() => {
        const handleScroll = () => {
            setScrolling(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div>

<Helmet>
        <title>Publications – NRD RUHS Articles Journal Jaipur</title>
        <meta
          name="description"
          content="Explore published research articles and medical journals from NRD RUHS Rajasthan University for Health Sciences, Jaipur."
        />
        <link rel="canonical" href="https://nrdruhs.in/publications" />
      </Helmet>


            {/* NAVBAR */}
            <nav className={`navBar ${scrolling ? 'scrolling' : ''}`} data-aos="fade-down" data-aos-duration="1200">
                {/* Logo Image */}
                <img src={logoImage} alt="Logo" className="logo" />

                {/* Hamburger Menu Button */}
                <div className="menuButton" onClick={toggleMenu}>
                    <div className={`menuIcon ${showMenu ? 'open' : ''}`} />
                </div>

                {/* Navigation Links */}
                <ul className={`navLinks ${showMenu ? 'show' : ''}`}>
                    <li><Link to="/" className="link">Home</Link></li>
                    <li><Link to="/aboutus" className="link">About NRD</Link></li>
                    <li><Link to="/issnpage" className="link">ISSN</Link></li>
                    <li><Link to="/editorialboard" className="link">Editorial Board</Link></li>
                    <li><Link to="#" className="link">Current Issue</Link></li>
                    <li><Link to="/publications" className="link">Publications</Link></li>

                    <NavDropdown title="Login" id="basic-nav-dropdown" style={{ fontWeight: 'bold' }}>
                        <NavDropdown.Item href="/login">
                            <FaUser style={{ marginRight: 6, color: 'Navy' }} /> Author
                        </NavDropdown.Item>
                        <NavDropdown.Item href="/reviewlogin">
                            <FaUserTie style={{ marginRight: 6, color: 'Chocolate' }} /> Reviewer
                        </NavDropdown.Item>
                        <NavDropdown.Item href="/adminlogin">
                            <FaUserCheck style={{ marginRight: 6, color: 'green' }} /> Admin
                        </NavDropdown.Item>
                    </NavDropdown>
                </ul>

                {/* Register Dropdown */}
                <NavDropdown title="Register" id="register-dropdown" style={{ fontWeight: 'bold', marginRight: 18, backgroundColor: 'red', padding: 15 }}>
                    <NavDropdown.Item href="/register">
                        <FaUser style={{ marginRight: 6, color: 'Navy' }} /> As an Author
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/registerreviewer">
                        <FaUserTie style={{ marginRight: 6, color: 'red' }} /> As a Reviewer
                    </NavDropdown.Item>
                </NavDropdown>
            </nav>

            <NRDRUHSHeader />

       {/* ISSN Content */}


<div className="row" style={{ marginTop: 45, marginBottom: 0, justifyContent: 'center', textAlign: 'center' }}>
       <h1 style={{marginBottom: 45}}>Publications</h1>
                



         <div style={{ marginBottom: '20px' }}>
                    <button
                        style={{
                            backgroundColor: '#ff2056',
                            color: 'white',
                            padding: '30px 60px',
                            fontSize: '24px',
                            fontWeight: 'bold',
                            borderRadius: '6px',
                            margin: '10px',
                            cursor: 'pointer',
                            border: 'none', // <-- This removes the border
                        }}
                        onClick={() => window.open('https://nrdruhs.in/uploads/National%20Research%20Denticon%20Vol%2014%20Issue%20No%204%20Oct-Dec%202025.html', '_blank')}
                    >
                        Vol 14 Issue No 4 Oct-Dec 2025
                    </button>
                </div>


      
                <div style={{ marginBottom: '20px' }}>
                    <button
                        style={{
                            backgroundColor: '#ff2056',
                            color: 'white',
                            padding: '30px 60px',
                            fontSize: '24px',
                            fontWeight: 'bold',
                            borderRadius: '6px',
                            margin: '10px',
                            cursor: 'pointer',
                            border: 'none', // <-- This removes the border
                        }}
                        onClick={() => window.open('https://nrdruhs.in/uploads/National%20Research%20Denticon%20Vol%2014%20Issue%20No%203%20Jul-Sep%202025.html', '_blank')}
                    >
                        Vol 14 Issue No 3 Jul-Sep 2025
                    </button>
                </div>
                





                
                <div style={{ marginBottom: '20px' }}>
                    <button
                        style={{
                            backgroundColor: '#ff2056',
                            color: 'white',
                            padding: '30px 60px',
                            fontSize: '24px',
                            fontWeight: 'bold',
                            borderRadius: '6px',
                            margin: '10px',
                            cursor: 'pointer',
                            border: 'none', // <-- This removes the border
                        }}
                        onClick={() => window.open('https://nrdruhs.in/uploads/National%20Research%20Denticon%20Vol%2014%20Issue%20No%202%20Apr-Jun%202025.html', '_blank')}
                    >
                        Vol 14 Issue No 2 Apr-Jun 2025
                    </button>
                </div>
        



       
                <div style={{ marginBottom: '20px' }}>
                    <button
                        style={{
                            backgroundColor: '#ff2056',
                            color: 'white',
                            padding: '30px 60px',
                            fontSize: '24px',
                            fontWeight: 'bold',
                            borderRadius: '6px',
                            margin: '10px',
                            cursor: 'pointer',
                            border: 'none', // <-- This removes the border
                        }}
                        onClick={() => window.open('https://nrdruhs.in/uploads/National%20Research%20Denticon%20Vol%2014%20Issue%20No%201%20Jan-Mar%202025.html', '_blank')}
                    >
                        Vol 14 Issue No 1 Jan-Mar 2025
                    </button>
                </div>
                




     
                <div style={{ marginBottom: '20px' }}>
                    <button
                        style={{
                            backgroundColor: '#ff2056',
                            color: 'white',
                            padding: '30px 60px',
                            fontSize: '24px',
                            fontWeight: 'bold',
                            borderRadius: '6px',
                            margin: '10px',
                            cursor: 'pointer',
                            border: 'none', // <-- This removes the border
                        }}
                        onClick={() => window.open('https://nrdruhs.in/uploads/National%20Research%20Denticon%20Vol%2013%20Issue%20No%201%20Oct-Dec%202024.html', '_blank')}
                    >
                        Vol 13 Issue No 4 Oct-Dec 2024
                    </button>
                </div>
                
        
            </div>

{/* Home Button at the bottom */}
            <div style={{ textAlign: 'center', marginBottom: 40 }}>
                <button
                    style={{
                        backgroundColor: '#007bff',
                        color: 'white',
                        padding: '15px 40px',
                        fontSize: '20px',
                        fontWeight: 'bold',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        border: 'none',
                        boxShadow: '0px 4px 6px rgba(0,0,0,0.2)',
                    }}
                    onClick={() => window.open('https://nrdruhs.in', '_self')}
                >
                    Home
                </button>
            </div>






            <NRDRUHSFooter />


            <noscript>
  <div>
    <h1>Publications – NRD RUHS</h1>
    <p>Read the official publications and research articles published under NRD RUHS Jaipur Rajasthan India.</p>
  </div>
</noscript>



        </div>
    );
}

export default Publications;
